import { ComponentStyleConfig } from "@chakra-ui/react";

const Toast: ComponentStyleConfig = {
  baseStyle: {},
  variants: {
    merchantt: {
      container: {
        bg: "green.500",
        icon: {
          color: "blue",
        },
      },
    },
  },
};

export default Toast;
